// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/img/Checkbox.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditMode_profileForm__erIAT {
  width: 100%;
  display: flex;
}
.EditMode_profileFormRow__c1T4\\+ {
  display: flex;
  justify-content: space-between;
  margin: 24px 0px 16px;
  gap: 64px;
}
.EditMode_profileFormColumn__XTiR0 {
  row-gap: 16px;
  width: 340px;
}
.EditMode_mobileRow__wUxCh,
.EditMode_closeButton__xDBtJ,
.EditMode_saveButton__ydWaK,
.EditMode_label__mo1p0 {
  display: flex;
  align-items: center;
}
.EditMode_mobileColumn__nOJU\\+,
.EditMode_profileForm__erIAT {
  align-items: baseline;
  justify-content: center;
}
.EditMode_mobileRow__wUxCh {
  justify-content: flex-start;
  width: 100%;
}
.EditMode_profileFormButtons__F5VLS {
  column-gap: 16px;
  display: flex;
  justify-content: end;
  margin-top: 34px;
  width: 90%;
}
.EditMode_closeButton__xDBtJ {
  background-color: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  height: 52px;
  width: 164px;
}
.EditMode_closeButtonText__P2Lkp {
  color: #808080;
}
.EditMode_saveButton__ydWaK,
.EditMode_closeButton__xDBtJ {
  transition: background-color 300ms ease-in-out;
  cursor: pointer;
  border: none;
}
.EditMode_saveButton__ydWaK:hover {
  background-color: #b98e29;
}
.EditMode_closeButton__xDBtJ:hover {
  background-color: #d4d3d3;
}
.EditMode_saveButton__ydWaK,
.EditMode_saveButtonDisabled__hrnin {
  border-radius: 4px;
  height: 52px;
  justify-content: center;
  width: 212px;
  border: none;
}
.EditMode_saveButton__ydWaK {
  background-color: #cb9c2d;
}
.EditMode_saveButtonDisabled__hrnin {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #cbba92;
  cursor: not-allowed;
}
.EditMode_saveButtonText__rzCj4 {
  color: #ffffff;
}
.EditMode_label__mo1p0,
.EditMode_closeButtonText__P2Lkp,
.EditMode_saveButtonText__rzCj4 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.EditMode_closeButtonText__P2Lkp,
.EditMode_saveButtonText__rzCj4 {
  margin: 0px;
}
.EditMode_profileForm__erIAT,
.EditMode_profileFormColumn__XTiR0,
.EditMode_mobileColumn__nOJU\\+ {
  display: flex;
  flex-direction: column;
}
.EditMode_label__mo1p0 {
  cursor: pointer;
  text-align: left;
  color: #828d9a;
}
.EditMode_checkboxInput__pSscV {
  display: none;
}
.EditMode_checkboxInput__pSscV:checked + .EditMode_checkboxCustom__y1his {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
}
.EditMode_checkboxCustom__y1his {
  width: 20px;
  height: 20px;
  border: 1px solid #e2e2e2;
  background-color: white;
  margin-right: 10px;
  border-radius: 8px;
}

@media screen and (max-width: 1024px) {
  .EditMode_profileFormRow__c1T4\\+ {
    flex-direction: column;
    align-items: baseline;
    width: 100%;
  }
  .EditMode_profileFormColumn__XTiR0 {
    width: 100%;
  }
  .EditMode_profileFormButtons__F5VLS {
    align-items: center;
    justify-content: center;
  }
  .EditMode_profileForm__erIAT {
    width: 95%;
  }
  .EditMode_saveButtonText__rzCj4,
  .EditMode_closeButtonText__P2Lkp {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/polazniciPregled/components/EditMode/EditMode.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;;EAEE,8CAA8C;EAC9C,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;EAEE,WAAW;AACb;AACA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,2EAA8E;AAChF;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".profileForm {\n  width: 100%;\n  display: flex;\n}\n.profileFormRow {\n  display: flex;\n  justify-content: space-between;\n  margin: 24px 0px 16px;\n  gap: 64px;\n}\n.profileFormColumn {\n  row-gap: 16px;\n  width: 340px;\n}\n.mobileRow,\n.closeButton,\n.saveButton,\n.label {\n  display: flex;\n  align-items: center;\n}\n.mobileColumn,\n.profileForm {\n  align-items: baseline;\n  justify-content: center;\n}\n.mobileRow {\n  justify-content: flex-start;\n  width: 100%;\n}\n.profileFormButtons {\n  column-gap: 16px;\n  display: flex;\n  justify-content: end;\n  margin-top: 34px;\n  width: 90%;\n}\n.closeButton {\n  background-color: #ebebeb;\n  border-radius: 4px;\n  cursor: pointer;\n  justify-content: center;\n  height: 52px;\n  width: 164px;\n}\n.closeButtonText {\n  color: #808080;\n}\n.saveButton,\n.closeButton {\n  transition: background-color 300ms ease-in-out;\n  cursor: pointer;\n  border: none;\n}\n.saveButton:hover {\n  background-color: #b98e29;\n}\n.closeButton:hover {\n  background-color: #d4d3d3;\n}\n.saveButton,\n.saveButtonDisabled {\n  border-radius: 4px;\n  height: 52px;\n  justify-content: center;\n  width: 212px;\n  border: none;\n}\n.saveButton {\n  background-color: #cb9c2d;\n}\n.saveButtonDisabled {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #cbba92;\n  cursor: not-allowed;\n}\n.saveButtonText {\n  color: #ffffff;\n}\n.label,\n.closeButtonText,\n.saveButtonText {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.closeButtonText,\n.saveButtonText {\n  margin: 0px;\n}\n.profileForm,\n.profileFormColumn,\n.mobileColumn {\n  display: flex;\n  flex-direction: column;\n}\n.label {\n  cursor: pointer;\n  text-align: left;\n  color: #828d9a;\n}\n.checkboxInput {\n  display: none;\n}\n.checkboxInput:checked + .checkboxCustom {\n  background: url(\"../../../../assets/img/Checkbox.png\") center center no-repeat;\n}\n.checkboxCustom {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  margin-right: 10px;\n  border-radius: 8px;\n}\n\n@media screen and (max-width: 1024px) {\n  .profileFormRow {\n    flex-direction: column;\n    align-items: baseline;\n    width: 100%;\n  }\n  .profileFormColumn {\n    width: 100%;\n  }\n  .profileFormButtons {\n    align-items: center;\n    justify-content: center;\n  }\n  .profileForm {\n    width: 95%;\n  }\n  .saveButtonText,\n  .closeButtonText {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileForm": `EditMode_profileForm__erIAT`,
	"profileFormRow": `EditMode_profileFormRow__c1T4+`,
	"profileFormColumn": `EditMode_profileFormColumn__XTiR0`,
	"mobileRow": `EditMode_mobileRow__wUxCh`,
	"closeButton": `EditMode_closeButton__xDBtJ`,
	"saveButton": `EditMode_saveButton__ydWaK`,
	"label": `EditMode_label__mo1p0`,
	"mobileColumn": `EditMode_mobileColumn__nOJU+`,
	"profileFormButtons": `EditMode_profileFormButtons__F5VLS`,
	"closeButtonText": `EditMode_closeButtonText__P2Lkp`,
	"saveButtonDisabled": `EditMode_saveButtonDisabled__hrnin`,
	"saveButtonText": `EditMode_saveButtonText__rzCj4`,
	"checkboxInput": `EditMode_checkboxInput__pSscV`,
	"checkboxCustom": `EditMode_checkboxCustom__y1his`
};
export default ___CSS_LOADER_EXPORT___;
